const newResultModel = require('./resultModel');

module.exports = function replaceResults(dtos, collection) {
    const models = dtos.filter(dto => dto.Found !== undefined)
                        .map(dto => newResultModel(dto.Found));
    collection.removeAll();
    collection.pushRange(models);
};
